import SearchIcon from "@mui/icons-material/Search";
import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { CancelChannel } from "api/Channel/CancelChannel";
import { RegisterChannel } from "../../../../../../api/Channel/RegisterChannel";
import Loading from "common/components/common/Loading";
import CoreAutocomplete from "common/components/forms_context/CoreAutocomplete";
import CoreInput from "common/components/forms_context/CoreInput";
import { useFetch } from "common/hooks/useFetch";
import { useOptionsTranslate } from "common/hooks/useOptions";
import { queryKeys } from "helper/react-query";
import { checkHaityPhoneNumber } from "helper/utils";
import _ from "lodash";
import { Option } from "modules/Channel/configs/constant";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { Form } from "react-router-dom";
import PageContainer from "theme/comtainer/PageContainer";
import ChannelInfo from "./ChannelInfo";
import HistoryInfo2 from "./History2";
import CancelAccount from "./CancelAccount";

const value = {
  channelTypeIdSearch: Option.ALL,
};
// 67075633331

const CancelCreateRequest = () => {
  const [isShowInfo, setIsShowInfo] = useState(false);

  const { t } = useTranslation("uaa");
  const form = useForm({ defaultValues: value, mode: "onChange" });

  const { handleSubmit, setValue, watch } = form;

  const { data: dataChannelType, isFetching: isLoadingChannelType } = useFetch(
    RegisterChannel.channelTypeByRole,
    null,
    queryKeys.GET_CHANNEL_TYPE_BY_ROLE,
    { enabled: true }
  );

  const channelTypeOptions = useOptionsTranslate({ data: dataChannelType, t });

  const {
    mutateAsync: getInfoCancelChannel,
    isLoading: isLoadingInfoCancelChannel,
  } = useMutation({
    mutationFn: CancelChannel.infoCancel,
    onSuccess: ({ data }) => {
      const { data: dataSuccess } = data;
      if (!data.hasOwnProperty("errorCodes") && dataSuccess) {
        setIsShowInfo(true);
        setValue("channelName", dataSuccess.channelName);
        setValue("channelId", dataSuccess.channelId);
        setValue("phoneNumber", dataSuccess.phoneNumber);
        setValue("channelType", dataSuccess.channelType);
        setValue("walletState", dataSuccess.walletState);
        setValue("channelState", dataSuccess.channelState);
        setValue("accountAR", dataSuccess.accountAR);
        setValue("accountBalance", dataSuccess.accountBalance);
        setValue("accountState", dataSuccess.accountState);
        setValue("currencyCode", dataSuccess.currencyCode);
        setValue("accountId", dataSuccess.accountId);
        setValue("accountState", dataSuccess.accountStateId);
        setValue("cancelAccountType", "Request from user to cancel account");
      } else {
        setIsShowInfo(false);
      }
    },
  });

  const onSearch = async (values) => {
    let payload = _.pick(values, ["phoneNumberSearch", "channelTypeIdSearch"]);

    await getInfoCancelChannel(payload);
  };

  return (
    <PageContainer title={t("title.cancel-channel")}>
      <FormProvider {...form}>
        <Form onSubmit={handleSubmit(onSearch)} className="mb-20">
          <Typography>{t(`title.search-info`)}</Typography>
          <Box className="grid desktop:grid-cols-3 tablet:grid-cols-3 mobile:grid-cols-1 gap-4 mt-8">
            <CoreInput
              name="phoneNumberSearch"
              type={"phone"}
              label={t(`label.phone-number`)}
              inputProps={{ maxLength: 11 }}
              required
              rules={{
                validate: (value) => {
                  if (!!value && checkHaityPhoneNumber(value)) {
                    // return `${t("message.error-invalid-haiti-phone")}`;
                    return "message.error-invalid-haiti-phone";
                  }
                },
              }}
            />
            <CoreAutocomplete
              name="channelTypeIdSearch"
              label={t(`label.channel-type`)}
              loading={isLoadingChannelType}
              options={[...(channelTypeOptions || [])]}
              defaultValue={Option.ALL}
            />

            <div className="flex justify-end">
              <LoadingButton
                variant="contained"
                color="primary"
                type="submit"
                loading={isLoadingInfoCancelChannel}
                className="text-right px-12 py-6 h-25 "
                startIcon={<SearchIcon />}
              >
                {t("btn.search")}
              </LoadingButton>
            </div>
          </Box>

          {isShowInfo ? (
            <>
              {isLoadingInfoCancelChannel ? (
                <Loading />
              ) : (
                <>
                  <ChannelInfo />
                  <HistoryInfo2
                    initValue={{ phoneNumber: watch("phoneNumberSearch") }}
                  />
                  <CancelAccount
                    setIsShowInfo={setIsShowInfo}
                    // setIsSearch={setIsSearch}
                  />
                </>
              )}
            </>
          ) : null}
        </Form>
      </FormProvider>
    </PageContainer>
  );
};

export default CancelCreateRequest;

// const IGNORE = [
//   "channelName",
//   "channelType",
//   "channelState",
//   "phoneNumber",
//   "accountAR",
//   "walletState",
//   "accountBalance",
//   "accountStateId",
//   "currencyCode",
//   "accountId",
//   "cancelAccountType",
//   "cancelReason",
//   "channelId",
// ];
// const convertPayload = (values) => {
//   let temp = _.omit(values, IGNORE);

//   return temp;
// };
